import * as React from "react";
const SvgChevronDown24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 8,
        fill: "black",
        viewBox: "0 0 12 8"
      },
      props
    ),
    React.createElement("path", { fill: "current", d: "M6 8 .5 0h11L6 8Z" })
  );
export default SvgChevronDown24Px;
